import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import { Plus } from 'lucide-react';
import TaskCard from './TaskCard';

const COL_META = {
  'To Do':       { dot: 'bg-indigo-500',  label: 'To Do',       badge: 'bg-indigo-500/10 text-indigo-400' },
  'In Progress': { dot: 'bg-amber-500',   label: 'In Progress', badge: 'bg-amber-500/10 text-amber-400' },
  'Completed':   { dot: 'bg-emerald-500', label: 'Completed',   badge: 'bg-emerald-500/10 text-emerald-400' },
};

const TaskColumn = ({ col, tasks, onAddTask, onEditTask }) => {
  const meta = COL_META[col];

  return (
    <div className="flex flex-col bg-white dark:bg-[#161929] border border-gray-200 dark:border-gray-700/60 rounded-2xl overflow-hidden min-h-[200px]">
      {/* Column header */}
      <div className="flex items-center justify-between px-4 py-3.5 border-b border-gray-100 dark:border-gray-700/60">
        <div className="flex items-center gap-2.5">
          <span className={`w-2 h-2 rounded-full ${meta.dot}`} />
          <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-100">{meta.label}</h2>
        </div>
        <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${meta.badge}`}>{tasks.length}</span>
      </div>

      {/* Droppable area */}
      <Droppable droppableId={col}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`flex-1 p-3 flex flex-col gap-2.5 min-h-[100px] transition-colors ${snapshot.isDraggingOver ? 'drag-over-highlight' : ''}`}
          >
            {tasks.length === 0 && !snapshot.isDraggingOver && (
              <div className="flex-1 flex items-center justify-center">
                <p className="text-xs text-gray-300 dark:text-gray-600 text-center py-4">Drop tasks here</p>
              </div>
            )}
            {tasks.map((task, index) => (
              <Draggable key={task.id} draggableId={task.id} index={index}>
                {(prov, snap) => (
                  <TaskCard task={task} onEdit={onEditTask} provided={prov} snapshot={snap} />
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>

      {/* Add task button */}
      <div className="px-3 pb-3">
        <button
          onClick={() => onAddTask(col)}
          className="w-full flex items-center justify-center gap-1.5 py-2 text-xs text-gray-400 dark:text-gray-600 border border-dashed border-gray-200 dark:border-gray-700 rounded-lg hover:border-indigo-400 dark:hover:border-indigo-500 hover:text-indigo-500 dark:hover:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-500/5 transition-all"
        >
          <Plus size={13} /> Add task
        </button>
      </div>
    </div>
  );
};

export default TaskColumn;
